import { z } from "zod";

const hexColorRegex = /^#[0-9a-fA-F]{3,8}$/;

export const communityPublicConfigResponseSchema = z.object({
	enabled: z.literal(true),
	community_name: z.string(),
	community_slug: z.string(),
	contact_email: z.email().nullable(),
	app_name: z.string().max(100).nullable(),
	color_primary: z.string().regex(hexColorRegex).nullable(),
	color_secondary: z.string().regex(hexColorRegex).nullable(),
	color_splash: z.string().regex(hexColorRegex).nullable(),
	icon_url: z.url().nullable(),
});

export type CommunityPublicConfigResponse = z.infer<typeof communityPublicConfigResponseSchema>;
